import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.company.NoSubscription', {
    emptySubscriptions: 'There are no applicable subscriptions.',
});
